import { useAuth } from '../context/AuthContext';
import { hasRoutePermission, filterMenuItemsByPermission } from '../utils/permissions';

/**
 * Hook personalizado para verificar permissões de acesso
 * Facilita a verificação de permissões em qualquer componente
 * @returns {Object} Funções para verificação de permissões
 */
export const usePermissions = () => {
  const { user } = useAuth();
  
  /**
   * Verifica se o usuário atual tem permissão para acessar uma rota
   * @param {string} route - A rota a ser verificada
   * @returns {boolean} - True se o usuário tem permissão, false caso contrário
   */
  const checkRoutePermission = (route) => {
    if (!user || !user.cargo || !route) return false;
    return hasRoutePermission(route, user.cargo);
  };
  
  /**
   * Filtra um array de itens de menu com base nas permissões do usuário atual
   * @param {Array} menuItems - Array de itens de menu com propriedade path
   * @returns {Array} - Array filtrado apenas com os itens que o usuário tem acesso
   */
  const filterMenuItems = (menuItems) => {
    if (!user || !user.cargo || !menuItems) return [];
    return filterMenuItemsByPermission(menuItems, user.cargo);
  };
  
  /**
   * Verifica se o usuário tem um cargo específico
   * @param {string|Array} cargos - Um cargo ou array de cargos para verificar
   * @returns {boolean} - True se o usuário tem um dos cargos especificados
   */
  const hasRole = (cargos) => {
    if (!user || !user.cargo) return false;
    
    // Se cargos for um array, verifica se o cargo do usuário está no array
    if (Array.isArray(cargos)) {
      return cargos.includes(user.cargo);
    }
    
    // Se cargos for uma string, compara diretamente
    return user.cargo === cargos;
  };
  
  return {
    checkRoutePermission,
    filterMenuItems,
    hasRole,
    userCargo: user?.cargo
  };
};

export default usePermissions; 